export const gradeList = ['K1', 'K2', 'K3', 'P1', 'P2', 'P3', 'P4', 'P5', 'P6', 'S1', 'S2', 'S3', 'S4', 'S5', 'S6'];
export const excludeMenuList = ['requirement', 'student-requirement', 'online-course', 'notify', 'blog', 'student-blog', 'video', 'setting-requirement', 'enquiry'];
